import { render, staticRenderFns } from "./assignment-task-table.vue?vue&type=template&id=7280d94f"
import script from "./assignment-task-table.vue?vue&type=script&lang=js"
export * from "./assignment-task-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports